// import { classNames } from 'primereact/utils'

const buttonGroup = {
    root: {
      // className:  classNames('border *:first:rounded-l-none')
    },
}

export default buttonGroup
